export enum EDriverVerificationSection {
  STATUS_CARD = 'status_card',
  GUESTS = 'guests',
}

export enum EDriverFailedReasons {
  NOT_AUTHORIZED = 'user is not logged in',
  GENERIC = 'id-verfication failed on server end',
}
